import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-how-does-it-work',
  templateUrl: './how-does-it-work.component.html',
  styleUrls: ['./how-does-it-work.component.scss']
})
export class HowDoesItWorkComponent implements OnInit {
  currentUser: any;
  login: boolean = false;
  obfuscated: boolean = false;
  loading: boolean = true;
  activeSection = '';

  constructor(
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    let castUser: Subscription;

    castUser = this.authService.castCurrentUser.subscribe(async (res: any) => {
      this.currentUser = await res;
      if (this.currentUser?.id) {
        this.userService.personalInfo(this.currentUser?.id).subscribe((res: any) => {
          this.login = !(res?.subscribed === false || res?.user_plan === 1);
          this.obfuscated = !!res?.obfuscated;
          this.loading = false;

          if (this.login) {
            this.initObserver();
          }
        });
      } else {
        this.login = false;
        this.loading = false;
      }
      castUser.unsubscribe();
    });
  }

  private initObserver() {
    setTimeout(() => {

      const sections = Array.from(
        document.querySelectorAll('section[id]')
      ) as HTMLElement[];

      const observer = new IntersectionObserver(
        () => {
          let closestSection = '';
          let minOffset = Number.POSITIVE_INFINITY;

          sections.forEach(section => {
            const rect = section.getBoundingClientRect();

            // distance from top (adjust 120 based on header)
            const offset = Math.abs(rect.top - 120);

            if (rect.top <= window.innerHeight && offset < minOffset) {
              minOffset = offset;
              closestSection = section.id;
            }
          });

          if (closestSection) {
            this.activeSection = closestSection;
          }
        },
        {
          root: null,
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        }
      );

      sections.forEach(section => observer.observe(section));

    }, 200);
  }

  scrollTo(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (!element) return;

    element.scrollIntoView({ behavior: 'smooth', block: 'start' });

    this.waitForScrollEnd(() => {
      this.activeSection = sectionId;
    });
  }

  private waitForScrollEnd(callback: () => void) {
    let timeout: any;

    const handler = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        window.removeEventListener('scroll', handler);
        callback();
      }, 100);
    };

    window.addEventListener('scroll', handler);
  }
}


